// ============================================================
// Features.js
// Place in: frontend/src/pages/Features.js
// CSS file:  frontend/src/styles/features.css
// ============================================================

import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Login from './Login';
import '../styles/features.css';

// ------------------------------------------------------------
// ProfessionalIcon — stroke-based outline icons (24x24)
// NOTE: Agar tumhare project mein pehle se ProfessionalIcon
// component bana hai (HowItWorks.js / LandingPage), is local
// component ko hata kar usko import kar lo:
//   import ProfessionalIcon from '../components/ProfessionalIcon';
// Props yahan: name, size, strokeWidth, className, style
// ------------------------------------------------------------
const ICON_PATHS = {
    sparkle: (
        <>
            <path d="M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8L12 3z" />
            <path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15z" />
        </>
    ),
    settings: (
        <>
            <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
            <circle cx="12" cy="12" r="3" />
        </>
    ),
    bot: (
        <>
            <rect x="4" y="8" width="16" height="12" rx="3" />
            <path d="M12 8V5" />
            <circle cx="12" cy="3.8" r="1.2" />
            <path d="M2 13v3M22 13v3" />
            <path d="M9 13.5v1.5M15 13.5v1.5" />
            <path d="M9.5 18h5" />
        </>
    ),
    chart: (
        <>
            <path d="M3 21h18" />
            <rect x="5" y="11" width="3" height="8" rx="0.5" />
            <rect x="10.5" y="6" width="3" height="13" rx="0.5" />
            <rect x="16" y="13" width="3" height="6" rx="0.5" />
        </>
    ),
    shield: <path d="M12 3l8 3v6c0 4.5-3.2 8.2-8 9-4.8-.8-8-4.5-8-9V6l8-3z" />,
    'shield-check': (
        <>
            <path d="M12 3l8 3v6c0 4.5-3.2 8.2-8 9-4.8-.8-8-4.5-8-9V6l8-3z" />
            <path d="M8.5 12l2.5 2.5 4.5-5" />
        </>
    ),
    flow: (
        <>
            <rect x="8.5" y="3" width="7" height="5" rx="1.5" />
            <rect x="2.5" y="16" width="7" height="5" rx="1.5" />
            <rect x="14.5" y="16" width="7" height="5" rx="1.5" />
            <path d="M12 8v4" />
            <path d="M6 16v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2" />
        </>
    ),
    phone: (
        <>
            <rect x="7" y="2.5" width="10" height="19" rx="2.5" />
            <path d="M11 18.5h2" />
        </>
    ),
    branch: (
        <>
            <circle cx="6" cy="5" r="2" />
            <circle cx="6" cy="19" r="2" />
            <circle cx="18" cy="9" r="2" />
            <path d="M6 7v10" />
            <path d="M18 11c0 3-2 5-6 5H8" />
        </>
    ),
    document: (
        <>
            <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z" />
            <path d="M14 3v5h5" />
            <path d="M9 13h6M9 17h4" />
        </>
    ),
    'file-down': (
        <>
            <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z" />
            <path d="M14 3v5h5" />
            <path d="M12 11.5v6M9.5 15l2.5 2.5 2.5-2.5" />
        </>
    ),
    'upload-download': (
        <>
            <path d="M8 4v12M4.5 12.5L8 16l3.5-3.5" />
            <path d="M16 20V8M12.5 11.5L16 8l3.5 3.5" />
        </>
    ),
    bolt: <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" />,
    users: (
        <>
            <circle cx="9" cy="8" r="3.5" />
            <path d="M2.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6" />
            <circle cx="17.5" cy="9" r="2.5" />
            <path d="M17 14.2c2.6.3 4.5 2.2 4.5 5.3" />
        </>
    ),
    megaphone: (
        <>
            <path d="M3 10v4a1 1 0 0 0 1 1h3l9 5V4L7 9H4a1 1 0 0 0-1 1z" />
            <path d="M19 9a4 4 0 0 1 0 6" />
            <path d="M7 15l1.5 5h2.5L10 16" />
        </>
    ),
    'calendar-clock': (
        <>
            <rect x="3" y="4.5" width="18" height="16" rx="2.5" />
            <path d="M3 9.5h18M8 3v3M16 3v3" />
            <circle cx="15.5" cy="15.5" r="3" />
            <path d="M15.5 14v1.7l1 .6" />
        </>
    ),
    'image-stack': (
        <>
            <rect x="6" y="3" width="15" height="14" rx="2" />
            <path d="M3 7v11a3 3 0 0 0 3 3h11" />
            <circle cx="11" cy="8" r="1.3" />
            <path d="M6 14l4-4 3.5 3.5 2-2 5.5 5.5" />
        </>
    ),
    'lock-key': (
        <>
            <rect x="4.5" y="10.5" width="15" height="10.5" rx="2.5" />
            <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
            <circle cx="12" cy="15" r="1.3" />
            <path d="M12 16.3v2" />
        </>
    ),
    lock: (
        <>
            <rect x="5" y="10.5" width="14" height="10" rx="2.5" />
            <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
        </>
    ),
    globe: (
        <>
            <circle cx="12" cy="12" r="9" />
            <path d="M3 12h18" />
            <path d="M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3z" />
        </>
    ),
    'bot-handoff': (
        <>
            <circle cx="9" cy="8" r="3.5" />
            <path d="M2.5 20c0-3.6 2.9-6 6.5-6 1.2 0 2.3.3 3.2.7" />
            <path d="M15 17h6M18.5 14l3 3-3 3" />
        </>
    ),
    'trending-up': (
        <>
            <path d="M3 17l6-6 4 4 8-8" />
            <path d="M15 7h6v6" />
        </>
    ),
    search: (
        <>
            <circle cx="11" cy="11" r="6.5" />
            <path d="M16 16l4.5 4.5" />
        </>
    ),
    server: (
        <>
            <rect x="3" y="4" width="18" height="6.5" rx="2" />
            <rect x="3" y="13.5" width="18" height="6.5" rx="2" />
            <path d="M7 7.25h.01M7 16.75h.01" />
        </>
    ),
    building: (
        <>
            <path d="M4 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" />
            <path d="M16 9h2a2 2 0 0 1 2 2v10" />
            <path d="M2.5 21h19" />
            <path d="M8 7.5h4M8 11.5h4M8 15.5h4" />
        </>
    ),
    check: <path d="M5 12.5l4.5 4.5L19 7.5" />,
    x: <path d="M6 6l12 12M18 6L6 18" />,
    clock: (
        <>
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3.5 2" />
        </>
    ),
    'code-off': (
        <>
            <path d="M8 8l-4 4 4 4" />
            <path d="M16 8l4 4-4 4" />
            <path d="M4 4l16 16" />
        </>
    ),
    rocket: (
        <>
            <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
            <path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
            <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
            <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
        </>
    ),
    diamond: (
        <>
            <path d="M6 4h12l4 6-10 11L2 10l4-6z" />
            <path d="M2 10h20M9 4l3 6 3-6M12 10v11" />
        </>
    ),
    mail: (
        <>
            <rect x="3" y="5" width="18" height="14" rx="2.5" />
            <path d="M3.5 7l8.5 6 8.5-6" />
        </>
    ),
    user: (
        <>
            <circle cx="12" cy="8" r="4" />
            <path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5" />
        </>
    ),
    'chevron-right': <path d="M9 6l6 6-6 6" />,
    'arrow-right': <path d="M5 12h14M13 6l6 6-6 6" />,
};

function ProfessionalIcon({ name, size = 20, strokeWidth = 1.8, className = '', style }) {
    const content = ICON_PATHS[name];
    if (!content) return null;
    return (
        <svg
            className={`feat-icon ${className}`.trim()}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            style={style}
        >
            {content}
        </svg>
    );
}

// small inline layout helper (icon + text side by side)
const rowStyle = { display: 'inline-flex', alignItems: 'center', gap: 8 };

function Features() {
    const navigate = useNavigate();
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('all');
    const isAuthenticated = !!localStorage.getItem('token');

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Intersection Observer — scroll animations
    useEffect(() => {
        const targets = document.querySelectorAll(
            '.feat-animate, .feat-animate-left, .feat-animate-right, .feat-card'
        );
        const observer = new IntersectionObserver(
            (entries) => entries.forEach(e => {
                if (e.isIntersecting) e.target.classList.add('feat-visible');
            }),
            { threshold: 0.12 }
        );
        targets.forEach(el => observer.observe(el));
        return () => observer.disconnect();
    }, [activeTab]);

    const tabs = [
        { id: 'all',       label: 'All Features',    icon: 'sparkle'  },
        { id: 'core',      label: 'Core Platform',   icon: 'settings' },
        { id: 'ai',        label: 'AI & Automation', icon: 'bot'      },
        { id: 'analytics', label: 'Analytics',       icon: 'chart'    },
        { id: 'security',  label: 'Security',        icon: 'shield'   },
    ];

    // ── Feature groups data ────────────────────────────────
    const groups = [
        {
            id: 'core',
            icon: 'settings',
            title: 'Core Platform',
            sub: 'Everything you need to build and deploy WhatsApp chatbots without writing a single line of code',
            cards: [
                {
                    icon: 'flow',
                    title: 'Visual Flow Builder',
                    desc: 'Drag-and-drop conversation designer with unlimited nodes and branches. Combine messages, interactive buttons, images, documents, conditions, labels, and multi-language detection — see exactly how your bot will respond before going live.',
                    tags: [
                        { label: 'No Code', color: '' },
                        { label: 'Drag & Drop', color: '' },
                        { label: 'Live Preview', color: 'blue' },
                    ],
                },
                {
                    icon: 'phone',
                    title: 'WhatsApp Business API',
                    desc: 'Official Meta-approved WhatsApp Business API integration. Send text, images, videos, PDFs, location pins, and interactive button messages — fully compliant with WhatsApp policies.',
                    tags: [
                        { label: 'Meta Approved', color: '' },
                        { label: 'Interactive Msgs', color: 'blue' },
                        { label: 'Media Support', color: 'purple' },
                    ],
                },
                {
                    icon: 'branch',
                    title: 'Smart Branching & Conditions',
                    desc: 'Create intelligent conversation paths based on user input, keywords, time of day, or custom variables. Your bot handles every scenario — including unexpected replies — gracefully.',
                    tags: [
                        { label: 'Keyword Triggers', color: '' },
                        { label: 'Conditional Logic', color: 'purple' },
                        { label: 'Fallback Handling', color: 'orange' },
                    ],
                },
                {
                    icon: 'upload-download',
                    title: 'Export & Import Flows',
                    desc: 'Export any flow as a JSON file and import it into another account or workspace whenever you need. Keep backups of your best conversation designs and reuse them without rebuilding from scratch.',
                    tags: [
                        { label: 'JSON Export', color: '' },
                        { label: 'One-Click Import', color: 'blue' },
                        { label: 'Backup & Reuse', color: '' },
                    ],
                },
                {
                    icon: 'bolt',
                    title: 'Instant Deployment',
                    desc: 'No server setup, no DevOps headaches. Once your flow is ready, publish it with one click to your WhatsApp number — and unpublish just as easily. Updates go live in real-time without downtime.',
                    tags: [
                        { label: 'Publish / Unpublish', color: '' },
                        { label: 'Zero Downtime', color: '' },
                        { label: 'Instant Updates', color: 'blue' },
                    ],
                },
                {
                    icon: 'users',
                    title: 'Smart Escalation',
                    desc: 'When a conversation needs a human touch, the bot detects the right department automatically — or lets the customer pick one — and routes the chat straight to the responsible team member on their phone number, with context intact.',
                    tags: [
                        { label: 'Auto Department Detect', color: 'orange' },
                        { label: 'Manual Selection', color: '' },
                        { label: 'Direct to Phone', color: 'blue' },
                    ],
                },
                {
                    icon: 'megaphone',
                    title: 'Bulk Campaigns & Broadcast',
                    desc: 'Upload an Excel or CSV file of numbers and send a text or approved WhatsApp template campaign to thousands of contacts at once. Track sent, delivered, read, and failed status per recipient, resend failures in one click, and export the full campaign log to Excel.',
                    tags: [
                        { label: 'Excel / CSV Import', color: '' },
                        { label: 'Template Campaigns', color: 'blue' },
                        { label: 'Failed Resend', color: 'orange' },
                        { label: 'Excel Export', color: 'purple' },
                    ],
                },
            ],
        },
        {
            id: 'ai',
            icon: 'bot',
            title: 'AI & Automation',
            sub: 'Reusable AI assistants that live inside your flows, talk to customers naturally, and know exactly when to hand off to a human',
            cards: [
                {
                    icon: 'bot',
                    title: 'AI Assistants That Know When to Hand Off',
                    desc: 'Create reusable AI assistants once — pick the model (GPT-4o, GPT-4o mini, GPT-4 Turbo, or GPT-3.5 Turbo), write your business instructions, and set the creativity level. Then drop an assistant into any flow as a node. It keeps talking to the customer until its task is complete, remembers the conversation per contact, and automatically understands the surrounding flow and already-collected variables — no need to rewrite your flow inside a prompt. When it finishes, the "Done" output continues your flow; when the customer wants a person, the "Handoff" output routes to Smart Escalation or an agent.',
                    tags: [
                        { label: 'Reusable Assistants', color: 'orange' },
                        { label: 'Flow-Aware Context', color: '' },
                        { label: 'Per-Contact Memory', color: 'purple' },
                        { label: 'Done / Handoff Outputs', color: 'blue' },
                    ],
                    wide: true,
                    mockType: 'ai',
                },
                {
                    icon: 'calendar-clock',
                    title: 'Scheduled Messages',
                    desc: 'Send WhatsApp messages automatically at the right time — once at a specific date and time, or daily at a fixed time. Set it once and it sends itself, with no manual triggering.',
                    tags: [
                        { label: 'One-Time Send', color: 'blue' },
                        { label: 'Daily Recurring', color: '' },
                        { label: 'Fully Automatic', color: 'purple' },
                    ],
                },
                {
                    icon: 'image-stack',
                    title: 'Smart Media Auto-Send',
                    desc: 'Upload images, videos, and documents to your media library and attach trigger keywords to each file. When a customer message matches a keyword, the right file is sent automatically along with the AI text reply.',
                    tags: [
                        { label: 'Keyword Triggers', color: 'orange' },
                        { label: 'Images, Video & Docs', color: 'blue' },
                        { label: 'AI Media Library', color: '' },
                    ],
                },
                {
                    icon: 'globe',
                    title: 'Multilingual Support',
                    desc: 'Reach customers in their own language. Your bot automatically detects whether a customer is writing in Hindi or English and replies in the matching language, so every conversation feels natural.',
                    tags: [
                        { label: 'Hindi & English', color: '' },
                        { label: 'Auto Detect', color: 'blue' },
                    ],
                },
                {
                    icon: 'lock-key',
                    title: 'OTP Verification API',
                    desc: 'A standalone product for developers. Send WhatsApp OTPs straight from your own website, app, or backend using a simple REST API key — no WhatsApp integration to build yourself. Generate and revoke keys from the dashboard and receive delivery status callbacks on your own server, all on the official WhatsApp Business API.',
                    tags: [
                        { label: 'For Developers', color: 'orange' },
                        { label: 'REST API Key', color: '' },
                        { label: 'Delivery Callbacks', color: 'blue' },
                        { label: 'Key Management', color: 'purple' },
                    ],
                },
            ],
        },
        {
            id: 'analytics',
            icon: 'chart',
            title: 'Analytics & Insights',
            sub: 'Deep visibility into every conversation, every metric — so you can continuously improve performance',
            cards: [
                {
                    icon: 'trending-up',
                    title: 'Real-Time Dashboard',
                    desc: 'See live message volume, active conversations, response times, and bot performance metrics updating in real-time. Know exactly how your chatbot is performing at every moment.',
                    tags: [
                        { label: 'Live Metrics', color: '' },
                        { label: 'Custom Date Range', color: 'blue' },
                    ],
                },
                {
                    icon: 'search',
                    title: 'Conversation Analytics',
                    desc: 'Analyse every conversation — where users drop off, which buttons are clicked most, what questions the AI couldn\'t answer. Use this data to continuously improve your flows.',
                    tags: [
                        { label: 'Drop-off Analysis', color: 'orange' },
                        { label: 'Click Heatmaps', color: '' },
                        { label: 'AI Gaps Report', color: 'purple' },
                    ],
                },
                {
                    icon: 'file-down',
                    title: 'Performance Reports',
                    desc: 'Generate detailed PDF/CSV reports on resolution rates, average response time, customer satisfaction scores, and bot vs agent handling ratios. Share with your team in one click.',
                    tags: [
                        { label: 'PDF & CSV Export', color: '' },
                        { label: 'CSAT Tracking', color: '' },
                        { label: 'Team Sharing', color: 'blue' },
                    ],
                },
            ],
        },
        {
            id: 'security',
            icon: 'shield',
            title: 'Security & Reliability',
            sub: 'Secure, isolated, and dependable infrastructure — your business never goes offline',
            cards: [
                {
                    icon: 'shield-check',
                    title: 'End-to-End Encryption',
                    desc: 'Messages and customer data are protected in transit and handled on secure infrastructure. Your customer conversations stay within the platform and are never shared across accounts.',
                    tags: [
                        { label: 'Encrypted in Transit', color: '' },
                        { label: 'Secure Infrastructure', color: 'blue' },
                        { label: 'Privacy-Focused', color: '' },
                    ],
                },
                {
                    icon: 'server',
                    title: '99.9% Uptime SLA',
                    desc: 'Our infrastructure is built on redundant cloud servers with auto-failover. We guarantee 99.9% uptime backed by an SLA — your chatbot stays live even during peak traffic.',
                    tags: [
                        { label: '99.9% SLA', color: '' },
                        { label: 'Auto-Failover', color: 'orange' },
                        { label: 'Global CDN', color: 'blue' },
                    ],
                },
                {
                    icon: 'building',
                    title: 'Organization-Level Data Isolation',
                    desc: 'ChatTech24 is a multi-tenant platform where every organization\'s data — contacts, flows, conversations, and campaigns — is completely separate and isolated from every other organization.',
                    tags: [
                        { label: 'Multi-Tenant', color: 'purple' },
                        { label: 'Isolated Data', color: '' },
                        { label: 'Per-Organization', color: 'blue' },
                    ],
                },
            ],
        },
    ];

    // Comparison table data
    const compareRows = [
        { feature: 'Visual Flow Builder (No Code)',        ours: true,  others: 'partial', generic: false },
        { feature: 'Official WhatsApp Business API',       ours: true,  others: true,      generic: false },
        { feature: 'GPT-4 AI Integration',                 ours: true,  others: false,     generic: false },
        { feature: 'OTP Verification API',                 ours: true,  others: false,     generic: false },
        { feature: 'Human Handoff with History',           ours: true,  others: 'partial', generic: false },
        { feature: 'Broadcast Campaigns',                  ours: true,  others: true,      generic: false },
        { feature: 'Bulk Campaign Management',             ours: true,  others: 'partial', generic: false },
        { feature: 'Scheduled/Recurring Messages',         ours: true,  others: 'partial', generic: false },
        { feature: 'Real-Time Analytics Dashboard',        ours: true,  others: 'partial', generic: false },
        { feature: 'Multilingual AI Support',              ours: true,  others: false,     generic: false },
        { feature: 'GDPR / Data Encryption',               ours: true,  others: true,      generic: false },
        { feature: 'Setup Time Under 30 Minutes',          ours: true,  others: false,     generic: false },
    ];

    const easeStats = [
        { icon: 'clock',    num: '< 30', label: 'Min Setup',       sub: 'From account creation to live bot' },
        { icon: 'code-off', num: '0',    label: 'Lines of Code',   sub: 'Completely no-code platform' },
        { icon: 'rocket',   num: '4',    label: 'Steps to Go Live', sub: 'Connect, build, preview, publish' },
        { icon: 'sparkle',  num: '0',    label: 'Training Needed', sub: 'Intuitive for any skill level' },
    ];

    const visibleGroups = activeTab === 'all'
        ? groups
        : groups.filter(g => g.id === activeTab);

    const renderTag = (tag, i) => (
        <span key={i} className={`feat-card-tag ${tag.color === 'blue' ? 'feat-card-tag-blue' : tag.color === 'purple' ? 'feat-card-tag-purple' : tag.color === 'orange' ? 'feat-card-tag-orange' : ''}`}>
            {tag.label}
        </span>
    );

    const renderCompareCell = (val) => {
        if (val === true)      return <span className="feat-check-yes"><ProfessionalIcon name="check" size={18} strokeWidth={2.4} /></span>;
        if (val === false)     return <span className="feat-check-no"><ProfessionalIcon name="x" size={16} strokeWidth={2.2} /></span>;
        if (val === 'partial') return <span className="feat-check-partial">Partial</span>;
        return null;
    };

    return (
        <div className="feat-page">

            {/* ── NAVBAR ── */}
            <nav className={`ct-nav ${scrolled ? 'ct-nav-scrolled' : ''}`}>
                <div className="ct-nav-brand" onClick={() => navigate('/')}>
                    <img src="/logo.png" alt="ChatTech24" style={{ height: '44px', width: 'auto', objectFit: 'contain' }} />
                </div>
                <div className="ct-nav-links">
                    <Link to="/how-it-works" className="ct-nav-link">How It Works</Link>
                    <Link to="/features" className="ct-nav-link" style={{ color: '#128C7E', fontWeight: 700 }}>Features</Link>
                    <Link to="/services" className="ct-nav-link">Services</Link>
                    <Link to="/pricing" className="ct-nav-link">Pricing</Link>
                    <Link to="/contact" className="ct-nav-link">Contact</Link>
                </div>
                <div className="ct-nav-actions">
                    {isAuthenticated ? (
                        <button onClick={() => navigate('/dashboard')} className="ct-btn-primary">
                            <span style={{ ...rowStyle, gap: 6 }}>Dashboard <ProfessionalIcon name="arrow-right" size={16} /></span>
                        </button>
                    ) : (
                        <>
                            <button onClick={() => setLoginModalOpen(true)} className="ct-btn-ghost">Login</button>
                            <button onClick={() => navigate('/pricing')} className="ct-btn-primary">Get Started</button>
                        </>
                    )}
                </div>
                <button className="ct-nav-hamburger" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                    <span /><span /><span />
                </button>
            </nav>

            {/* Mobile Menu */}
            {mobileMenuOpen && (
                <div className="ct-nav-mobile">
                    <div className="ct-mobile-menu-header">
                        <div
                            className="ct-mobile-menu-brand"
                            onClick={() => { navigate('/'); setMobileMenuOpen(false); }}
                            style={{ gap: '2px', cursor: 'pointer' }}
                        >
                            <img src="/logo 1.png" alt="ChatTech24" style={{ height: '36px', width: 'auto', objectFit: 'contain' }} />
                            <span style={{ color: '#D3D3D3', fontFamily: 'Sora, sans-serif', fontSize: '12px', fontWeight: '700' }}>ChatTech24</span>
                        </div>
                        <button className="ct-mobile-menu-close" onClick={() => setMobileMenuOpen(false)} aria-label="Close menu">
                            <ProfessionalIcon name="x" size={18} strokeWidth={2.2} />
                        </button>
                    </div>
                    <div className="ct-mobile-menu-links">
                        <Link to="/how-it-works" className="ct-mobile-link" onClick={() => setMobileMenuOpen(false)}>
                            <span className="ct-mobile-link-icon"><ProfessionalIcon name="settings" size={20} /></span><span>How It Works</span><span className="ct-mobile-link-arrow"><ProfessionalIcon name="chevron-right" size={18} /></span>
                        </Link>
                        <Link to="/features" className="ct-mobile-link" onClick={() => setMobileMenuOpen(false)}>
                            <span className="ct-mobile-link-icon"><ProfessionalIcon name="sparkle" size={20} /></span><span>Features</span><span className="ct-mobile-link-arrow"><ProfessionalIcon name="chevron-right" size={18} /></span>
                        </Link>
                        <Link to="/services" className="ct-mobile-link" onClick={() => setMobileMenuOpen(false)}>
                            <span className="ct-mobile-link-icon"><ProfessionalIcon name="rocket" size={20} /></span><span>Services</span><span className="ct-mobile-link-arrow"><ProfessionalIcon name="chevron-right" size={18} /></span>
                        </Link>
                        <Link to="/pricing" className="ct-mobile-link" onClick={() => setMobileMenuOpen(false)}>
                            <span className="ct-mobile-link-icon"><ProfessionalIcon name="diamond" size={20} /></span><span>Pricing</span><span className="ct-mobile-link-arrow"><ProfessionalIcon name="chevron-right" size={18} /></span>
                        </Link>
                        <Link to="/contact" className="ct-mobile-link" onClick={() => setMobileMenuOpen(false)}>
                            <span className="ct-mobile-link-icon"><ProfessionalIcon name="phone" size={20} /></span><span>Contact</span><span className="ct-mobile-link-arrow"><ProfessionalIcon name="chevron-right" size={18} /></span>
                        </Link>
                    </div>
                    <div className="ct-mobile-menu-actions">
                        <button className="ct-mobile-btn-login" onClick={() => { setLoginModalOpen(true); setMobileMenuOpen(false); }}>
                            <span style={rowStyle}><ProfessionalIcon name="user" size={18} /> Login</span>
                        </button>
                        <button className="ct-mobile-btn-cta" onClick={() => { navigate('/pricing'); setMobileMenuOpen(false); }}>
                            <span style={rowStyle}><ProfessionalIcon name="rocket" size={18} /> Get Started</span>
                        </button>
                    </div>
                    <div className="ct-mobile-menu-footer">
                        <span style={rowStyle}><ProfessionalIcon name="lock" size={14} /> Secure & Reliable</span>
                        <span style={rowStyle}><ProfessionalIcon name="bolt" size={14} /> 99.9% Uptime</span>
                    </div>
                </div>
            )}

            {/* ── HEADER ── */}
            <div className="feat-header">
                <div className="feat-header-badge"><ProfessionalIcon name="sparkle" size={14} /> Platform Features</div>
                <h1 className="feat-header-title">
                    Everything You Need to <span>Automate</span><br />WhatsApp Like a Pro
                </h1>
                <p className="feat-header-subtitle">
                    ChatTech24 is built differently — no-code, AI-powered, and deeply integrated with WhatsApp Business API. Here's every tool at your disposal.
                </p>
                <div className="feat-header-stats">
                    <div className="feat-header-stat">
                        <div className="feat-header-stat-num">18+</div>
                        <div className="feat-header-stat-label">Core Features</div>
                    </div>
                    <div className="feat-header-stat">
                        <div className="feat-header-stat-num">No-Code</div>
                        <div className="feat-header-stat-label">Visual Builder</div>
                    </div>
                    <div className="feat-header-stat">
                        <div className="feat-header-stat-num">99.9%</div>
                        <div className="feat-header-stat-label">Uptime SLA</div>
                    </div>
                    <div className="feat-header-stat">
                        <div className="feat-header-stat-num">0</div>
                        <div className="feat-header-stat-label">Code Required</div>
                    </div>
                </div>
            </div>

            {/* ── CATEGORY TABS ── */}
            <div className="feat-tabs-section">
                <div className="feat-tabs-inner">
                    {tabs.map(t => (
                        <button
                            key={t.id}
                            className={`feat-tab ${activeTab === t.id ? 'feat-tab-active' : ''}`}
                            onClick={() => setActiveTab(t.id)}
                        >
                            <ProfessionalIcon name={t.icon} size={16} />
                            <span>{t.label}</span>
                        </button>
                    ))}
                </div>
            </div>

            {/* ── FEATURE GROUPS ── */}
            <div className="feat-main">
                {visibleGroups.map((group) => (
                    <div key={group.id} className="feat-group">
                        <div className="feat-group-header feat-animate">
                            <div className="feat-group-icon-box"><ProfessionalIcon name={group.icon} size={26} /></div>
                            <div>
                                <h2 className="feat-group-title">{group.title}</h2>
                                <p className="feat-group-sub">{group.sub}</p>
                            </div>
                        </div>

                        <div className={`feat-cards-grid ${group.cards.filter(c => c.wide).length > 0 ? '' : ''}`}>
                            {group.cards.map((card, ci) => (
                                card.wide ? (
                                    <div key={ci} className="feat-card feat-card-wide feat-animate">
                                        <div className="feat-card-accent" />
                                        <div>
                                            <div className="feat-card-icon"><ProfessionalIcon name={card.icon} size={28} /></div>
                                            <h3 className="feat-card-title">{card.title}</h3>
                                            <p className="feat-card-desc">{card.desc}</p>
                                            <div className="feat-card-tags">
                                                {card.tags.map(renderTag)}
                                            </div>
                                        </div>
                                        <div className="feat-card-wide-right">
                                            {/* AI Assistant node mock */}
                                            <div className="feat-mini-mock">
                                                <div style={{ ...rowStyle, fontSize: 12, fontWeight: 700, color: '#475569', marginBottom: 10 }}>
                                                    <ProfessionalIcon name="bot" size={15} /> AI Assistant node — live example
                                                </div>
                                                <div style={{ background: '#e5ddd5', borderRadius: 10, padding: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
                                                    <div style={{ background: '#dcf8c6', borderRadius: 8, padding: '7px 10px', alignSelf: 'flex-end', fontSize: 12, color: '#1a1a1a', maxWidth: '80%' }}>
                                                        I want to change my delivery address.
                                                    </div>
                                                    <div style={{ background: 'white', borderRadius: 8, padding: '7px 10px', fontSize: 12, color: '#1a1a1a', maxWidth: '85%', lineHeight: 1.5 }}>
                                                        Sure, I can help with that. Please share your order ID and the new address.
                                                    </div>
                                                </div>
                                                <div className="feat-mini-mock-row">
                                                    <span className="feat-mini-mock-label" style={{ ...rowStyle, gap: 6, color: '#128C7E', fontWeight: 700 }}>
                                                        <ProfessionalIcon name="check" size={14} strokeWidth={2.4} /> Done
                                                    </span>
                                                    <span className="feat-mini-mock-label">Flow continues</span>
                                                </div>
                                                <div className="feat-mini-mock-bar" style={{ marginTop: 8 }}>
                                                    <div className="feat-mini-mock-fill" style={{ width: '100%' }} />
                                                </div>
                                                <div className="feat-mini-mock-row">
                                                    <span className="feat-mini-mock-label" style={{ ...rowStyle, gap: 6, color: '#92400e', fontWeight: 700 }}>
                                                        <ProfessionalIcon name="bot-handoff" size={14} /> Handoff <ProfessionalIcon name="arrow-right" size={13} />
                                                    </span>
                                                    <span className="feat-mini-mock-label">Smart Escalation / Agent</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div key={ci} className="feat-card feat-animate">
                                        <div className="feat-card-accent" />
                                        <div className="feat-card-icon"><ProfessionalIcon name={card.icon} size={24} /></div>
                                        <h3 className="feat-card-title">{card.title}</h3>
                                        <p className="feat-card-desc">{card.desc}</p>
                                        <div className="feat-card-tags">
                                            {card.tags.map(renderTag)}
                                        </div>
                                    </div>
                                )
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            {/* ── EASE OF USE ── */}
            {(activeTab === 'all' || activeTab === 'core') && (
                <div className="feat-ease">
                    <div className="feat-ease-header">
                        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '6px 16px', background: 'rgba(37,211,102,0.1)', border: '1px solid rgba(37,211,102,0.25)', borderRadius: 100, fontSize: 13, fontWeight: 600, color: '#065f46', marginBottom: 14 }}>
                            <ProfessionalIcon name="check" size={14} strokeWidth={2.4} /> Ease of Use
                        </div>
                        <h2 style={{ fontFamily: 'Sora, sans-serif', fontSize: 34, fontWeight: 800, color: '#0f172a', margin: '0 0 10px' }}>
                            Built for Everyone — Not Just Developers
                        </h2>
                        <p style={{ fontSize: 16, color: '#64748b', margin: 0 }}>
                            If you can use WhatsApp, you can build a chatbot on ChatTech24
                        </p>
                    </div>
                    <div className="feat-ease-grid">
                        {easeStats.map((s, i) => (
                            <div key={i} className="feat-ease-card feat-animate">
                                <span className="feat-ease-emoji"><ProfessionalIcon name={s.icon} size={38} strokeWidth={1.6} /></span>
                                <div className="feat-ease-num">{s.num}</div>
                                <div className="feat-ease-label">{s.label}</div>
                                <div className="feat-ease-sub">{s.sub}</div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* ── COMPARISON TABLE ── */}
            {(activeTab === 'all') && (
                <div className="feat-compare">
                    <div className="feat-compare-inner">
                        <div className="feat-compare-header feat-animate">
                            <div className="feat-compare-badge"><ProfessionalIcon name="bolt" size={14} /> Why ChatTech24</div>
                            <h2 className="feat-compare-title">How We Compare to Generic Solutions</h2>
                            <p className="feat-compare-sub">See why 10,000+ businesses chose ChatTech24 over other tools</p>
                        </div>
                        <div style={{ overflowX: 'auto' }}>
                            <table className="feat-compare-table feat-animate">
                                <thead>
                                    <tr>
                                        <th style={{ width: '40%' }}>Feature</th>
                                        <th className="feat-compare-ours">
                                            <span style={{ ...rowStyle, gap: 6 }}>ChatTech24 <ProfessionalIcon name="check" size={16} strokeWidth={2.4} /></span>
                                        </th>
                                        <th>Other Platforms</th>
                                        <th>DIY / Generic</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {compareRows.map((row, i) => (
                                        <tr key={i}>
                                            <td>{row.feature}</td>
                                            <td className="feat-compare-col-ours">{renderCompareCell(row.ours)}</td>
                                            <td>{renderCompareCell(row.others)}</td>
                                            <td>{renderCompareCell(row.generic)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}

            {/* ── CTA ── */}
            <div className="feat-cta">
                <h2 className="feat-cta-title">Start Using Every Feature Today</h2>
                <p className="feat-cta-sub">No credit card required · 14-day free trial · Cancel anytime</p>
                <div className="feat-cta-btns">
                    <button onClick={() => navigate('/pricing')} className="feat-btn-white">
                        <ProfessionalIcon name="rocket" size={18} /> Start Free Trial
                    </button>
                    <button onClick={() => navigate('/how-it-works')} className="feat-btn-outline">
                        <ProfessionalIcon name="settings" size={18} /> See How It Works
                    </button>
                </div>
            </div>

            {/* ── FOOTER ── */}
            <footer className="ct-footer">
                <div className="ct-container">
                    <div className="ct-footer-grid">
                        <div>
                            <div className="ct-nav-brand" onClick={() => navigate('/')} style={{ gap: '2px', cursor: 'pointer' }}>
                                <img src="/logo 1.png" alt="ChatTech24" style={{ height: '44px', width: 'auto', objectFit: 'contain' }} />
                                <span style={{ color: '#D3D3D3', fontFamily: 'Cooper Black', fontSize: '13px', fontWeight: '700' }}>Chat Tech 24</span>
                            </div>
                            <p className="ct-footer-tagline">AI-powered WhatsApp automation platform for modern businesses.</p>
                            <div className="ct-footer-social">
                                <a href="https://vedvika.com" target="_blank" rel="noopener noreferrer" className="ct-footer-social-link">
                                    <span style={{ ...rowStyle, gap: 6 }}><ProfessionalIcon name="globe" size={15} /> Website</span>
                                </a>
                                <Link to="/contact" className="ct-footer-social-link">
                                    <span style={{ ...rowStyle, gap: 6 }}><ProfessionalIcon name="mail" size={15} /> Contact</span>
                                </Link>
                            </div>
                        </div>
                        <div className="ct-footer-col">
                            <div className="ct-footer-col-title">Product</div>
                            <Link to="/pricing">Pricing</Link>
                            <Link to="/features">Features</Link>
                            <Link to="/services">Services</Link>
                            <Link to="/how-it-works">How It Works</Link>
                        </div>
                        <div className="ct-footer-col">
                            <div className="ct-footer-col-title">Company</div>
                            <a href="https://vedvika.com/#about" target="_blank" rel="noopener noreferrer">About Vedvika</a>
                            <Link to="/contact">Contact Us</Link>
                        </div>
                        <div className="ct-footer-col">
                            <div className="ct-footer-col-title">Support</div>
                            <Link to="/how-it-works">Documentation</Link>
                            <Link to="/contact">Talk to Sales</Link>
                            <a href="mailto:support@chattech24.com">Email Support</a>
                        </div>
                    </div>
                    <div className="ct-footer-bottom">
                        <p className="ct-footer-copy">
                            © 2026 ChatTech24 by <a href="https://vedvika.com" target="_blank" rel="noopener noreferrer">Vedvika Technologies</a>. All rights reserved.
                        </p>
                        <div className="ct-footer-legal">
                            <a href="https://vedvika.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                            <a href="https://vedvika.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
                        </div>
                    </div>
                </div>
            </footer>

            <Login isOpen={loginModalOpen} onClose={() => setLoginModalOpen(false)} />
        </div>
    );
}

export default Features;